import React from 'react';
import { Text } from 'ui-builder';
import { useTimezonesHelper } from './timezones';
import dayjs from 'dayjs';

export function TimezoneDisplay(props: {
  value?: string,
  label?: string
}) {
  const deviceTimezone = dayjs.tz.guess();
  const timezonesHelper = useTimezonesHelper(deviceTimezone);

  if (!props.value) {
    return <Text>-</Text>;
  }

  const formattedValue = timezonesHelper.getLabel(props.value);

  return (
    <>
      {props.label && <Text bold>{props.label}: </Text>}
      <Text>{formattedValue}</Text>
    </>
  );
}
